import type { SxProps, Theme } from '@mui/material/styles';

import Typography from '@/shared/ui/typography/Text';

const disclaimerSx: SxProps<Theme> = {
  fontSize: '14px',
  fontWeight: 500,
  color: 'gx.subtext',
  px: 2,
  py: 1
};

// Route wording changes through design review, not ad-hoc edits.
const InputDisclaimer = () => (
  <Typography
    align='center'
    sx={disclaimerSx}
  >
    GX Go Assistant is an AI. Indexes shown are GX-published, not AI-generated. Explanations may
    contain errors. Please verify.
  </Typography>
);

export default InputDisclaimer;
